<template lang="html">
  <div id="reschedulingListPage">
    <h1 class="header">授業振替依頼の一覧ページ</h1>
    <h2>以下の授業振替依頼が届いております。依頼を承諾または拒否してください</h2>
  </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    name: 'reschedulingListPage'
  }
</script>
<style lang="css" scoped>
  #reschedulingReceiverPage {
    text-align: center;
    font-family: 'Avenir','Helvetica Neue','Helvetica','Arial','Hiragino Sans','ヒラギノ角ゴシック',YuGothic,'Yu Gothic','メイリオ', Meiryo,'ＭＳ Ｐゴシック','MS PGothic', 'sans-serif';
    margin-bottom: 50px;
  }
  .header {
    background-color: #ffd500;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    text-shadow:  -2px 2px 2px white,
                  -2px -2px 2px white,
                  2px -2px 2px white,
                  2px 2px 2px white;
  }
</style>



// WEBPACK FOOTER //
// ReschedulingListPage.vue?0cfad9b5